import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';


@Component({
  selector: 'app-custom-footer',
  templateUrl: './custom-footer.component.html',
  styleUrls: ['./custom-footer.component.scss'],
})
export class CustomFooterComponent implements OnInit {

  displaytooltip;


  constructor(
    private router: Router,
  ) { }

  ngOnInit() {
    this.displaytooltip = JSON.parse(localStorage.getItem('tooltip'));

  }

  
  navigateToConversation(event){
    this.router.navigate(['/seekers-pool']);

  }
  navigateToGroups(event) {
    this.router.navigate(['/groups']);
  }
  
  
  navigateToDisciples(event) {
    this.router.navigate(['/tab-home/tab-disciples']);
  }

  
  navigateToLeader(event) {
    this.router.navigate(['/contact-leader']);
  }

}
